const READY_ATTR = 'data-localization-disclosure-ready';

const selectors = {
  root: '[data-localization-disclosure]',
  trigger: '[data-localization-disclosure-trigger]',
  panel: '[data-localization-disclosure-panel]',
  option: '[data-localization-disclosure-option]',
  input: 'input[name="locale_code"], input[name="country_code"]',
  form: 'form',
};

export default class LocalizationDisclosure {
  /**
   * @param {HTMLElement} root
   */
  constructor(root) {
    this.root = root;
    this.elements = {
      input: root.querySelector(selectors.input),
      button: root.querySelector(selectors.trigger),
      panel: root.querySelector(selectors.panel),
    };

    if (!this.elements.button || !this.elements.panel || !this.elements.input) {
      return;
    }

    this.onButtonClick = this.openSelector.bind(this);
    this.onButtonFocusOut = this.closeSelector.bind(this);
    this.onKeyUp = this.onContainerKeyUp.bind(this);
    this.onLinkClick = this.onItemClick.bind(this);

    this.elements.button.addEventListener('click', this.onButtonClick);
    this.elements.button.addEventListener('focusout', this.onButtonFocusOut);
    this.root.addEventListener('keyup', this.onKeyUp);

    this.root.querySelectorAll(selectors.option).forEach(item => {
      item.addEventListener('click', this.onLinkClick);
    });
  }

  /**
   * @param {ParentNode} [scope]
   */
  static init(scope = document) {
    scope
      .querySelectorAll(`${selectors.root}:not([${READY_ATTR}])`)
      .forEach(el => {
        el.setAttribute(READY_ATTR, '');
        new LocalizationDisclosure(el);
      });
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') {
      return;
    }

    if (this.elements.button.getAttribute('aria-expanded') === 'false') {
      return;
    }
    this.hidePanel();
    event.stopPropagation();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.root.querySelector(selectors.form);
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) {
      form.submit();
    }
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute(
      'aria-expanded',
      (
        this.elements.button.getAttribute('aria-expanded') === 'false'
      ).toString(),
    );
  }

  closeSelector(event) {
    const isChild =
      this.elements.panel.contains(event.relatedTarget) ||
      this.elements.button.contains(event.relatedTarget);
    if (!event.relatedTarget || !isChild) {
      this.hidePanel();
    }
  }
}
